import { ExportAllListActions } from '../ExportAllButton';
import React from 'react';
import { Grid, Typography } from '@mui/material';
import { ListGuesser, ShowGuesser, CreateGuesser } from '@api-platform/admin';
import {
  TextField,
  FileField,
  FileInput,
  ReferenceField,
  useRecordContext,
  SelectInput,
  ReferenceInput,
  useGetOne,
  TextInput,
} from 'react-admin';
import { Link } from 'react-router-dom';
import { getSelectedCompanyFilter } from '../../helper/filter';

export const MediaObjectList = (props) => {
  const filters = [
    <TextInput label="Filename" source="fileName" />,
    <TextInput label="S3 Url" source="s3Url" />,
  ];

  const companyFilter = getSelectedCompanyFilter();

  return (
    <ListGuesser
      actions={<ExportAllListActions />}
      {...props}
      filters={filters}
      filter={companyFilter}
    >
      <TextField source={'fileName'} />
      <ReferenceField
        label="Company"
        source="company"
        sortBy={'company.name'}
        reference="companies"
      >
        <TextField source="name" id={'company'} />
      </ReferenceField>
    </ListGuesser>
  );
};

export const MediaObjectShow = (props) => {
  return (
    <ShowGuesser>
      <Grid container spacing={4} sx={{ p: 2 }}>
        <Grid item xs={6}>
          <Typography variant="caption" display="block" gutterBottom>
            Filename
          </Typography>
          <TextField source={'fileName'} />
          <Typography variant="caption" display="block" gutterBottom>
            Url
          </Typography>
          <TextField source={'s3Url'} />
          <Typography variant="caption" display="block" gutterBottom>
            Company
          </Typography>
          <ReferenceField
            label="Company"
            source="company"
            sortBy={'company.name'}
            reference="companies"
          >
            <TextField source="name" />
          </ReferenceField>
          <CoursesList />
          <CategoriesList />
        </Grid>
        <Grid item xs={6}>
          <ImagePreview />
        </Grid>
      </Grid>
    </ShowGuesser>
  );
};

const ImagePreview = (props) => {
  const record = useRecordContext();

  const { data, isLoading } = useGetOne('media_objects', {
    id: `${record.id}/file`,
  });

  if (isLoading) {
    return null;
  }

  return (
    <img
      src={data.signedUrl}
      style={{ maxWidth: '100%' }}
      title="title"
      alt={''}
    />
  );
};

const CoursesList = (props) => {
  const record = useRecordContext();

  const { data, isLoading } = useGetOne('media_objects', {
    id: `${record.id}/courses`,
  });

  if (isLoading) {
    return null;
  }

  return (
    <>
      <Typography variant="caption" display="block" gutterBottom>
        Courses
      </Typography>
      <p>
        {data.courses.map((i) => {
          return (
            <Link to={`/courses/${encodeURIComponent(i['@id'])}`}>
              {i.code}
            </Link>
          );
        })}
      </p>
    </>
  );
};

const CategoriesList = (props) => {
  const record = useRecordContext();

  const { data, isLoading } = useGetOne('media_objects', {
    id: `${record.id}/categories`,
  });

  if (isLoading) {
    return null;
  }

  return (
    <>
      <Typography variant="caption" display="block" gutterBottom>
        Categories
      </Typography>
      <p>
        {data.categories.map((i) => {
          return (
            <Link to={`/categories/${encodeURIComponent(i['@id'])}`}>
              {i.name}
            </Link>
          );
        })}
      </p>
    </>
  );
};

export const MediaObjectCreate = (props) => {
  const companyFilter = getSelectedCompanyFilter();

  return (
    <CreateGuesser {...props}>
      <ReferenceInput
        source="company"
        reference="companies"
        label="Company"
        filterToQuery={(searchText) => ({ name: searchText })}
      >
        <SelectInput
          required
          fullWidth
          source="company"
          id={'company'}
          optionText="name"
          disabled={true}
          defaultValue={companyFilter.company}
        />
      </ReferenceInput>
      <FileInput source="file" id={'file'}>
        <FileField source="src" id={'src'} title="title" />
      </FileInput>
    </CreateGuesser>
  );
};
